import { put, takeEvery } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { putSettings, type SecretPermission } from '@/modules/api/codegen';

import { updateSettingsFailure, updateSettingsSuccess, type updateSettings } from '../actions';
import types from '../actionTypes';

function* handler({ payload: { defaultPermission, sharingPermission }, meta }: ReturnType<typeof updateSettings>) {
    try {
        const { data } = yield putSettings({ sharingPermission, defaultPermission: defaultPermission as SecretPermission });

        yield put(updateSettingsSuccess(data));

        meta.success();
    } catch (e) {
        yield put(updateSettingsFailure(e));

        logger.error(e);

        meta.failure();
    }
}

export function* updateSettingsSaga() {
    yield takeEvery(types.UPDATE_SETTINGS, handler);
}
